import { all, takeLatest, call, put } from 'redux-saga/effects';
import { toast } from 'react-toastify';
import { getDegreeReportSuccess, getDegreeReportFailure } from './actions';

import api from '../../../services/api';
import { refreshTokenRequest } from '../auth/actions';
import { store } from '../../index';

export function* getDegreeReport({ payload }) {
  const { refresh_token } = store.getState().auth;

  try {
    const {
      institutionId,
      initialDate,
      finalDate,
      dateFilterCriteria,
      origin,
      onSuccess,
    } = payload;

    const response = yield call(
      (url) =>
        api.get(url, {
          params: {
            institutionId,
            docTypeId: 2,
            initialDate,
            finalDate,
            dateFilterCriteria,
            origin,
          },
        }),
      '/management/reports/document'
    );

    const { data } = response;

    yield put(getDegreeReportSuccess(data));

    if (onSuccess) {
      onSuccess();
    }
  } catch (err) {
    if (err.response?.status === 403) {
      yield put(refreshTokenRequest(refresh_token));
    } else {
      yield put(getDegreeReportFailure());
      toast.error('Falha ao buscar degrees');
    }
  }
}

export default all([takeLatest('@degree/REQUEST', getDegreeReport)]);
